import moment from 'moment';

const Utils = {};


Utils.formatDate = date => date ? moment(date).format("D MMM YYYY") : "-";

export default Utils;